exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "dt[data-v-04d27a3a], dd[data-v-04d27a3a] {\n  margin-bottom: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\ndt[data-v-04d27a3a] {\n  min-width: 100px;\n  width: 30%;\n}\ndd[data-v-04d27a3a] {\n  width: 60%;\n}\n", ""]);
